import React from 'react'
import PropTypes from 'prop-types'
import moment from 'moment'
import { withStyles } from '@material-ui/core/styles'
import TextField from '@material-ui/core/TextField'
import DatePicker from 'react-datepicker'
import 'react-datepicker/dist/react-datepicker.css'
moment.locale('fr')

const styles = theme => ({
  root: {
    width: '100%'
  },
  focused: {
    '&:after': {
      borderBottom: '2px solid #FFFFFF'
    }
  },
  underline: {
    '&:before': {
      borderBottom: '2px solid #FFFFFF'
    }
  },
  input: {
    color: '#A6B9C8'
  }
})

class DateTimePickerComponent extends React.Component {
  constructor (props) {
    super(props)
    this.state = {
      startDate: props.value ? new Date(props.value) : null,
      isOpen: false
    }
  }

  handleChange (date) {
    this.setState({
      startDate: date
    })
    this.toggleCalendar()
    this.props.onChange(date.toJSON())
  }

  toggleCalendar (e) {
    e && e.preventDefault()
    this.setState({
      isOpen: !this.state.isOpen
    })
  }

  render () {
    const { classes } = this.props
    if (this.props.hasError && this.props.value === '') {
      return (
        <div>
          <div
            onClick={(e) => this.toggleCalendar(e)}>
            <TextField
              error
              className={classes.root}
              label={this.props.label}
              value={this.state.startDate ? moment(this.state.startDate).format('DD/MM/YYYY HH:mm') : ''}
              margin='normal'
              helperText="cliquez pour avoir la date et l'heure"
              InputProps={{
                classes: this.props.classes,
                readOnly: true
              }}
              InputLabelProps={{
                style: { color: '#F44335', fontSize: '14px', fontWeight: 500, fontStyle: 'normal' }
              }}
              FormHelperTextProps={{
                style: { color: '#F44335', fontSize: '10px' }
              }}
            />
          </div>
          {
            this.state.isOpen && (
              <DatePicker
                selected={this.state.startDate}
                onChange={(d) => this.handleChange(d)}
                showTimeSelect
                timeFormat='HH:mm'
                timeIntervals={1}
                timeCaption='time'
                inline
              />
            )
          }
        </div>
      )
    } else {
      return (
        <div>
          <div
            onClick={(e) => this.toggleCalendar(e)}>
            <TextField
              className={classes.root}
              label={this.props.label}
              value={this.state.startDate ? moment(this.state.startDate).format('DD/MM/YYYY HH:mm') : ''}
              margin='normal'
              helperText="cliquez pour avoir la date et l'heure"
              InputProps={{
                classes: this.props.classes,
                readOnly: true
              }}
              InputLabelProps={{
                style: { color: '#A6B9C8', fontSize: '14px', fontWeight: 500, fontStyle: 'normal' }
              }}
              FormHelperTextProps={{
                style: { color: '#A6B9C8', fontSize: '10px' }
              }}
            />
          </div>
          {
            this.state.isOpen && (
              <DatePicker
                selected={this.state.startDate}
                onChange={(d) => this.handleChange(d)}
                showTimeSelect
                timeFormat='HH:mm'
                timeIntervals={1}
                timeCaption='time'
                inline
              />
            )
          }
        </div>
      )
    }
  }
}

DateTimePickerComponent.propTypes = {
  classes: PropTypes.object.isRequired
}

export default withStyles(styles)(DateTimePickerComponent)
